import * as Yup from "yup";

export default Yup.object().shape({
    name: Yup.string().required("Please enter a Product name"),
    categoryId: Yup.number().min(1, "Please select a Category").required(),
    price: Yup.number().required("Please enter a Price"),
    audienceSize: Yup.number().required("Please enter Audience Size"),
    companyId: Yup.number().min(1, "Please select a Company").required()
});